module.exports = __webpack_public_path__ + "static/media/brands_armstrong.66dd8dec.svg";